import React, { useContext } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthContext } from './context/AuthContext';
import Login from './components/Auth/Login';
import AdminSignup from './components/Auth/AdminSignup';
import AdminLayout from './components/Admin/AdminLayout';
import AdminDashboard from './components/Admin/AdminDashboard';
import AddUser from './components/Admin/AddUsers';
import UserListing from './components/Admin/UserListing';
import AddLead from './components/Admin/AddLead';
import AdminLeadListing from './components/Admin/LeadListing';
import UserLayout from './components/User/UserLayout';
import UserDashboard from './components/User/UserDashboard';
import LeadListing from './components/User/LeadListing';
import ErrorBoundary from './components/Common/ErrorBoundary';
import './App.css';
import EmailCampaign from './components/Common/EmailCampaign';
import AdminEmailGenerator from './components/Admin/AdminEmailGenerator';
import UserEmailGenerator from './components/User/UserEmailGenerator';
import StatusCards from './components/Admin/StatusCards';
import UserStatusCards from './components/User/UserStatusCards';
import ExcelUpload from './components/Admin/ExcelUpload';
import UserAddLead from './components/User/AddLead';
import EditRequests from './components/Admin/EditRequests';
import Demos from './components/Admin/Demos';
import UserDemos from './components/User/Demos';
import EvaluationPilot from './components/Admin/EvaluationPilot';
import ClosedWon from './components/Admin/ClosedWon';
import UserEvaluationPilot from './components/User/EvaluationPilot';
import UserClosedWon from './components/User/ClosedWon';
import LeadGeneration from './components/Admin/LeadGeneration';
import ManagerLayout from './components/Manager/ManagerLayout';
import ManagerLeadListing from './components/Manager/ManagerLeadListing';
import ManagerDashboard from './components/Manager/ManagerDashboard';
import OnboardingListing from './components/Admin/OnboardingListing';
import OnboardingDetail from './components/Admin/OnboardingDetail';

function App() {
  const { token, role } = useContext(AuthContext);

  return (
    <div className="min-h-screen bg-gray-100">
      <Routes>
        {!token ? (
          <>
            <Route path="/login" element={<Login />} />            
            <Route path="/admin-signup" element={<AdminSignup />} />
            <Route path="*" element={<Navigate to="/login" />} />
          </>
        ) : role === 'admin' ? (
          <Route path="/admin" element={<AdminLayout />}>
            <Route path="dashboard" element={<ErrorBoundary><AdminDashboard /></ErrorBoundary>} />
            <Route path="add-user" element={<ErrorBoundary><AddUser /></ErrorBoundary>} />
            <Route path="user-listing" element={<ErrorBoundary><UserListing /></ErrorBoundary>} />
            <Route path="add-lead" element={<ErrorBoundary><AddLead /></ErrorBoundary>} />
            <Route path="lead-generation" element={<ErrorBoundary><LeadGeneration /></ErrorBoundary>} />
            <Route path="excel-upload" element={<ErrorBoundary><ExcelUpload /></ErrorBoundary>} />
            <Route path="lead-listing" element={<ErrorBoundary><AdminLeadListing /></ErrorBoundary>} />
            <Route path="edit-requests" element={<ErrorBoundary><EditRequests /></ErrorBoundary>} />
            <Route path="status-cards" element={<ErrorBoundary><StatusCards /></ErrorBoundary>} />
            <Route path="demos" element={<ErrorBoundary><Demos /></ErrorBoundary>} />
            <Route path="evaluation-pilot" element={<ErrorBoundary><EvaluationPilot /></ErrorBoundary>} />
            <Route path="closed-won" element={<ErrorBoundary><ClosedWon /></ErrorBoundary>} />
            <Route path="onboarding" element={<ErrorBoundary><OnboardingListing /></ErrorBoundary>} />
            <Route path="onboarding/:id" element={<ErrorBoundary><OnboardingDetail /></ErrorBoundary>} />
             <Route path="email-campaign" element={<ErrorBoundary><EmailCampaign role="admin" /></ErrorBoundary>} />
             <Route path="email-generator" element={<ErrorBoundary><AdminEmailGenerator /></ErrorBoundary>} />
            <Route index element={<Navigate to="dashboard" />} />
          </Route>
        ) : role === 'manager' ? (
          <Route path="/manager" element={<ManagerLayout />}>
            <Route path="dashboard" element={<ErrorBoundary><ManagerDashboard /></ErrorBoundary>} />
            <Route path="add-lead" element={<ErrorBoundary><AddLead /></ErrorBoundary>} />
            <Route path="lead-generation" element={<ErrorBoundary><LeadGeneration /></ErrorBoundary>} />
            <Route path="excel-upload" element={<ErrorBoundary><ExcelUpload /></ErrorBoundary>} />
            <Route path="lead-listing" element={<ErrorBoundary><ManagerLeadListing /></ErrorBoundary>} />
            <Route path="status-cards" element={<ErrorBoundary><StatusCards /></ErrorBoundary>} />
            <Route path="demos" element={<ErrorBoundary><Demos /></ErrorBoundary>} />
            <Route path="evaluation-pilot" element={<ErrorBoundary><EvaluationPilot /></ErrorBoundary>} />
            <Route path="closed-won" element={<ErrorBoundary><ClosedWon /></ErrorBoundary>} />
            <Route path="onboarding" element={<ErrorBoundary><OnboardingListing /></ErrorBoundary>} />
            <Route path="onboarding/:id" element={<ErrorBoundary><OnboardingDetail /></ErrorBoundary>} />
            <Route path="email-campaign" element={<ErrorBoundary><EmailCampaign role="manager" /></ErrorBoundary>} />
            <Route path="email-generator" element={<ErrorBoundary><AdminEmailGenerator /></ErrorBoundary>} />
            <Route index element={<Navigate to="dashboard" />} />
          </Route>
        ) : (
          <Route path="/user" element={<UserLayout />}>
            <Route path="dashboard" element={<ErrorBoundary><UserDashboard /></ErrorBoundary>} />
            <Route path="add-lead" element={<ErrorBoundary><UserAddLead /></ErrorBoundary>} />
            <Route path="lead-listing" element={<ErrorBoundary><LeadListing /></ErrorBoundary>} />
            <Route path="status-cards" element={<ErrorBoundary><UserStatusCards /></ErrorBoundary>} />
            <Route path="demos" element={<ErrorBoundary><UserDemos /></ErrorBoundary>} />
            <Route path="evaluation-pilot" element={<ErrorBoundary><UserEvaluationPilot /></ErrorBoundary>} />
            <Route path="closed-won" element={<ErrorBoundary><UserClosedWon /></ErrorBoundary>} />
              <Route path="email-campaign" element={<ErrorBoundary><EmailCampaign role="user" /></ErrorBoundary>} />
              <Route path="email-generator" element={<ErrorBoundary><UserEmailGenerator  /></ErrorBoundary>} />
            <Route index element={<Navigate to="dashboard" />} />
          </Route>
        )}
        <Route path="*" element={<Navigate to={
          role === 'admin' ? '/admin/dashboard' : 
          role === 'manager' ? '/manager/dashboard' : 
          '/user/dashboard'
        } />} />
      </Routes>
    </div>
  );
}

export default App;